import { render, staticRenderFns } from "./Createoffercategories.vue?vue&type=template&id=54d237a0&scoped=true&"
import script from "./Createoffercategories.vue?vue&type=script&lang=js&"
export * from "./Createoffercategories.vue?vue&type=script&lang=js&"
import style0 from "./Createoffercategories.vue?vue&type=style&index=0&id=54d237a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d237a0",
  null
  
)

export default component.exports